import AreaChart from "./areachart";
import PieChartUniGeneral from "./pie-chart-unigeneral";
import PieChartPopularSubs from "./pie-chart-popular-subs";
import HorizontalBarChart from "./horizontal-bar-chart";
import HorizontalBarChartSingle from "./horizontal-bar-chart-single";
import VerticalBarChart from "./vertical-bar-chart";
import getLast12MonthsData from "./getlastmonthdata";

export default {
  AreaChart,
  PieChartUniGeneral,
  PieChartPopularSubs,
  HorizontalBarChart,
  HorizontalBarChartSingle,
  VerticalBarChart,
  getLast12MonthsData,
};
